<template>
  <div id="sinDisplay">
    <div class="title">工业经济监测平台</div>
    <div class="iconBox">
      <!-- <router-link to="/screendisplay">
        <img src="../../assets/imgs/icon/icon_survey_blue.png" alt />
      </router-link>-->
      <router-link to="/home">
        <img src="../../assets/imgs/icon/icon_back.png" alt />
      </router-link>
    </div>
    <tab-cut tag="Sin" current="区域监测"></tab-cut>
  </div>
</template>

<script>
import TabCut from "@/components/tabCut/tabCut1920.vue"; //tab切换组件
export default {
  data() {
    return {};
  },
  components: {
    "tab-cut": TabCut
  }
};
</script>

<style lang="less" scoped>
#sinDisplay {
  background: url(../../assets/imgs/background/screen_bg.png) center no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 10px 30px;
  box-sizing: border-box;
  height: 100vh;
}
.title {
  text-align: center;
  margin-bottom: 30px;
  width: 940px;
  height: 72px;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  background: url(../../assets/imgs/background/top_title_bg.png) center
    no-repeat;
  background-size: 940px 72px;
  line-height: 72px;
}
.iconBox {
  position: fixed;
  top: 40px;
  right: 20px;
  img {
    margin-right: 20px;
  }
}
</style>